import { getApi, postApi, putApi, deleteApi } from './Api';

export const getHospitalList = async (count) => {
  const url = `/admin/hospital/all/page?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchHospitalNameList = async (value, count) => {
  const url = `/admin/hospital/getHospitalName/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchHospitalEmailList = async (value, count) => {
  const url = `/admin/hospital/getEmail/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getMigHospitalList = async () => {
  const url = `/admin/hospital/hospital-select`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getHospitalID = async (id) => {
  const url = `/admin/hospital/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const saveHospital = async (data) => {
  const url = `/admin/hospital/register`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const updateHospital = async (data) => {
  const url = `/admin/hospital/update`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const deleteHospital = async (id) => {
  const url = `/admin/hospital/${id}`;
  try {
    const response = await deleteApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const emailReinvte = async (data) => {
  const url = `/admin/member/email-invitation`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const emailCheck = async ({ email, hospitalId }) => {
  const url = `/admin/member/hospital-admin-duple-email-check?email=${email}&hospitalId=${hospitalId}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.error('Error => ', e);
    throw e;
  }
};

export const woundFlagDelete = async (id, woundListId) => {
  const url = `/admin/hospital/woundFlag?hospitalId=${id}&woundListId=${woundListId}`;
  try {
    const response = await deleteApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

// 미사용
export const getTotalHospitalList = async () => {
  const url = '/admin/hospital/all';
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
